import type { NavItem } from '../nav';

/**
 * Link target for a nav entry. Pages that aren't rebuilt yet live behind the app's
 * splat route (`/$`), which shows the placeholder; rebuilt pages have real, typed
 * routes. This is the one place nav data meets the typed router.
 */
export function navLinkProps(item: NavItem): { to: '/$'; params: { _splat: string } } {
  // Every nav path is also valid under the splat, and TanStack Router resolves the
  // concrete route first, so ready pages still land on their real route.
  return { to: '/$', params: { _splat: item.to.replace(/^\//, '') } };
}
